export default {
    src: import.meta.ROLLUP_FILE_URL_ZoP2ebLT5e$hm8jPkF9mgA,
    srcSet: `${import.meta.ROLLUP_FILE_URL_ZoP2ebLT5e$hm8jPkF9mgA} 300w, ${import.meta.ROLLUP_FILE_URL_2$LtLFQdS6IeO$uJxLxRJQ} 600w`,
    imageSet: `image-set(url("${import.meta.ROLLUP_FILE_URL_ZoP2ebLT5e$hm8jPkF9mgA}") 1x, url("${import.meta.ROLLUP_FILE_URL_2$LtLFQdS6IeO$uJxLxRJQ}") 2x)`,
    width: 300,
    height: 273,
};